import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const SpaceOperationsQuery: GraphQLTaggedNode = graphql`
	query SpaceOperationsQuery($spaceKey: String!) {
		space(key: $spaceKey) {
			id
			operations {
				operation
				targetType
			}
		}
	}
`;
